export enum SearchRelevanceExperimentVariants {
	Control = 'control',
	ExperimentGroupOneCookie = 'search_relevance_experiment_group_one',
	ExperimentGroupTwoCookie = 'search_relevance_experiment_group_two',
	ExperimentGroupThreeCookie = 'search_relevance_experiment_group_three',
}
